import styled, { keyframes } from 'styled-components'
const savingSpin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const SavingOverlay = styled.div`
  position: fixed;
  z-index: 9999;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(4px);
`

export const SavingCard = styled.div`
  width: min(390px, 100%);
  padding: 24px;
  border: 1px solid #ececec;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  background: #fff;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.14);
  text-align: center;

  strong {
    color: #262626;
    font-size: 16px;
  }

  span {
    color: #777;
    font-size: 12px;
    line-height: 1.5;
  }
`

export const SavingSpinner = styled.span`
  width: 34px;
  height: 34px;
  border: 4px solid #f2c5c5;
  border-top-color: #d60000;
  border-radius: 50%;
  animation: ${savingSpin} 0.8s linear infinite;
`

export const CoverCreateItinerary = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 420px;
  overflow: hidden;
  border-radius: 0 0 18px 18px;
  background: #ececec;

  @media (max-width: 600px) {
    height: 300px;
    border-radius: 0 0 12px 12px;
  }
`

export const CoverIcon = styled.img`
  height: 100%;
  object-fit: cover;
  width: 100%;
`

export const CoverOverlay = styled.div`
  position: absolute;
  inset: auto 0 0 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 34px 38px 28px;
  color: #fff;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.72),
    rgba(0, 0, 0, 0.28),
    transparent
  );

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
    padding: 28px 20px 18px;
  }
`

export const CoverTitle = styled.div`
  margin-bottom: 5px;
  font-size: 22px;
  font-weight: 700;
`

export const CoverHint = styled.div`
  max-width: 620px;
  font-size: 13px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.9);
`

export const CoverActions = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 10px;

  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
`

export const CoverButton = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 126px;
  height: 38px;
  padding: 0 16px;
  border: 1px solid #fff;
  border-radius: 7px;
  background: #d60000;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    background: #b90000;
    transform: translateY(-1px);
  }
`

export const CoverRemoveButton = styled.button`
  height: 38px;
  padding: 0 14px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 7px;
  background: rgba(0, 0, 0, 0.28);
  color: #fff;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.5);
  }
`

export const CoverFileInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`

export const CoverImage = styled.img`
  height: 350px;
  object-fit: cover;
  width: 600px;
  margin-bottom: 10px;

  @media (max-width: 600px) {
    height: 200px;
    width: 100%;
  }
`

export const RowContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

export const RowContainerOne = styled.div`
  display: flex;
  margin-bottom: 10px;
  width: 100%;
`

export const ColumnContainer = styled.div`
  flex: 0 0 33%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const FollowIcon = styled.img`
  display: flex;

  margin-left: 10px;
`

export const ContainerCreateItinerary = styled.div`
  width: min(1500px, 96%);
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;

  background-color: #fff;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const Title = styled.span`
  margin-top: 10px;
  margin-bottom: 10px;

  color: #4f4f4f;
  font-size: 18px;
  font-weight: bold;
`

export const InformationText = styled.span`
  width: 50%;

  margin-bottom: 10px;

  color: #a9a9a9;
  font-size: 10px;
`

export const Text = styled.span`
  width: 50%;

  margin-bottom: 10px;

  font-size: 14px;
  font-weight: 300;
`

export const Divider = styled.hr`
  width: 360px;
  height: 1px;

  margin: 10px 0 20px;

  color: #a9a9a9;
`

export const TitleContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Link = styled.span`
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  cursor: pointer;
  color: #337ab7;
`

export const Description = styled.div`
  font-size: 14px;
  margin-bottom: 10px;

  color: #4f4f4f;
`

export const Label = styled.label`
  margin-bottom: 10px;
  margin-top: 10px;

  color: #343434;
  font-size: 14px;
  font-weight: 600;

  & span {
    color: #d60000;
    font-size: 14px;
  }
`

export const Input = styled.input`
  width: 400px;
  height: 40px;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  padding-left: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  outline-color: #b22222;

  &::placeholder {
    font-size: 14px;
    color: #a9a9a9;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`

export const MonthInput = styled.input`
  width: 200px;
  height: 40px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  outline-color: #b22222;
  box-sizing: border-box;
  padding-left: 10px;

  &::placeholder {
    font-size: 16px;
  }
`

export const UploadInput = styled.input`
  width: 200px;
  height: 40px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  outline-color: #b22222;

  &::placeholder {
    font-size: 16px;
  }
`

export const PainelCreateItinerary = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;

  &.hidden {
    display: none;
  }
`

export const ContentCreateItinerary = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
`

export const TextArea = styled.textarea`
  width: 500px;
  height: 200px;
  border: 1px solid #dcdcdc;
  border-radius: 5px;
  outline-color: #b22222;
  margin-bottom: 20px;

  &::placeholder {
    font-size: 14px;
    padding-left: 10px;
    padding-top: 10px;
    color: #a9a9a9;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`

export const Select = styled.select`
  width: 300px;
  height: 30px;
  color: #000;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
  border-radius: 5px;
`

export const Upload = styled.input`
  width: 300px;
  border-radius: 5px;
  height: 30px;
  margin-bottom: 10px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
`

export const BasicInfoWorkspace = styled.div`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
`

export const BasicInfoHeader = styled.div`
  margin-bottom: 24px;

  h2 {
    margin: 8px 0 6px;
    color: #242424;
    font-size: 28px;
    line-height: 1.15;
  }

  p {
    max-width: 760px;
    margin: 0;
    color: #777;
    font-size: 12px;
    line-height: 1.55;
  }

  @media (max-width: 700px) {
    h2 {
      font-size: 23px;
    }
  }
`

export const BasicInfoEyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #d60000;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
`

export const RouteTypeSection = styled.section`
  margin-bottom: 18px;
  padding: 20px;
  border: 1px solid #ececec;
  border-radius: 16px;
  background: #fff;
`

export const SectionTitle = styled.div`
  margin-bottom: 14px;
  display: flex;
  flex-direction: column;
  gap: 3px;

  strong {
    color: #2e2e2e;
    font-size: 14px;
  }

  span {
    color: #8a8a8a;
    font-size: 10px;
    line-height: 1.4;
  }
`

export const RouteTypeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`

export const RouteTypeCard = styled.button<{ $active: boolean }>`
  position: relative;
  padding: 16px;
  border: 1px solid ${({ $active }) => ($active ? '#e00000' : '#e3e3e3')};
  border-radius: 14px;
  background: ${({ $active }) => ($active ? '#fff7f7' : '#fff')};
  color: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.18s ease;

  &:hover {
    border-color: ${({ $active }) => ($active ? '#e00000' : '#c9c9c9')};
    box-shadow: 0 8px 22px rgba(0, 0, 0, 0.05);
    transform: translateY(-1px);
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
  }
`

export const RouteTypeTop = styled.div`
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) 18px;
  gap: 10px;
  align-items: center;

  > div:nth-child(2) {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  strong {
    color: #2e2e2e;
    font-size: 14px;
  }

  span {
    color: #7c7c7c;
    font-size: 10px;
  }
`

export const RouteTypeIcon = styled.span<{ $active: boolean }>`
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ $active }) => ($active ? '#ffe8e8' : '#f4f4f4')};
  color: ${({ $active }) => ($active ? '#d90000' : '#777')};
  font-size: 16px;
`

export const RouteTypeRadio = styled.span<{ $active: boolean }>`
  width: 16px;
  height: 16px;
  border: 1px solid ${({ $active }) => ($active ? '#d90000' : '#c9c9c9')};
  border-radius: 50%;
  background: ${({ $active }) => ($active ? '#d90000' : '#fff')};
  box-shadow: ${({ $active }) => ($active ? 'inset 0 0 0 4px #fff' : 'none')};
`

export const RouteTypeVisibility = styled.div<{ $active: boolean }>`
  margin-top: 14px;
  padding: 11px 12px;
  border-radius: 10px;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  background: ${({ $active }) => ($active ? '#fff' : '#fafafa')};
  color: ${({ $active }) => ($active ? '#3d3d3d' : '#666')};

  > svg {
    flex: 0 0 auto;
    margin-top: 2px;
    color: ${({ $active }) => ($active ? '#d90000' : '#888')};
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  strong {
    font-size: 10px;
  }

  span {
    color: #7f7f7f;
    font-size: 9px;
    line-height: 1.45;
  }
`

export const BasicInfoCard = styled.section`
  padding: 20px;
  border: 1px solid #ececec;
  border-radius: 16px;
  background: #fff;
`

export const BasicInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  .wide {
    grid-column: span 2;
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    .wide {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 650px) {
    grid-template-columns: 1fr;

    .wide {
      grid-column: auto;
    }
  }
`

export const ModernField = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;

  label {
    display: flex;
    align-items: center;
    gap: 7px;
    color: #4b4b4b;
    font-size: 10px;
    font-weight: 800;

    svg {
      color: #d60000;
    }
  }

  > input {
    width: 100%;
    min-height: 42px;
    padding: 0 12px;
    border: 1px solid #dedede;
    border-radius: 9px;
    background: #fff;
    color: #333;
    font-family: inherit;
    font-size: 11px;
    outline: none;
  }

  > input:focus {
    border-color: #d90000;
    box-shadow: 0 0 0 3px rgba(217, 0, 0, 0.06);
  }

  small {
    color: #959595;
    font-size: 9px;
    line-height: 1.45;
  }
`

export const CurrencyInput = styled.div`
  min-height: 42px;
  border: 1px solid #dedede;
  border-radius: 9px;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: #fff;

  > span {
    height: 42px;
    padding: 0 11px;
    display: inline-flex;
    align-items: center;
    border-right: 1px solid #ececec;
    background: #fafafa;
    color: #707070;
    font-size: 10px;
    font-weight: 800;
  }

  input {
    min-width: 0;
    flex: 1;
    height: 40px;
    padding: 0 11px;
    border: 0;
    outline: none;
    font-family: inherit;
    font-size: 11px;
  }

  &:focus-within {
    border-color: #d90000;
    box-shadow: 0 0 0 3px rgba(217, 0, 0, 0.06);
  }
`

export const FinalStepWorkspace = styled.div`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
`

export const FinalStepHeader = styled.div`
  margin-bottom: 22px;

  h2 {
    margin: 8px 0 6px;
    color: #242424;
    font-size: 28px;
    line-height: 1.15;
  }

  p {
    max-width: 760px;
    margin: 0;
    color: #777;
    font-size: 12px;
    line-height: 1.55;
  }

  @media (max-width: 700px) {
    h2 {
      font-size: 23px;
    }
  }
`

export const FinalStepGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(320px, 0.7fr);
  gap: 18px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const FinalStepColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const FinalCard = styled.section`
  padding: 20px;
  border: 1px solid #ececec;
  border-radius: 16px;
  background: #fff;
`

export const FinalCardHeader = styled.div`
  margin-bottom: 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;

  > svg {
    flex: 0 0 auto;
    margin-top: 2px;
    color: #d60000;
    font-size: 15px;
  }

  > div {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  strong {
    color: #2e2e2e;
    font-size: 14px;
  }

  span {
    color: #888;
    font-size: 10px;
    line-height: 1.45;
  }
`

export const InterestGridModern = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const InterestChip = styled.button<{ $active: boolean }>`
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid ${({ $active }) => ($active ? '#d60000' : '#e8e8e8')};
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: ${({ $active }) => ($active ? '#d60000' : '#fafafa')};
  color: ${({ $active }) => ($active ? '#ffffff' : '#555555')};
  font-family: inherit;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    color 0.16s ease,
    box-shadow 0.16s ease,
    transform 0.16s ease;

  &:hover {
    border-color: #d60000;
    background: ${({ $active }) => ($active ? '#c40000' : '#fff4f4')};
    color: ${({ $active }) => ($active ? '#ffffff' : '#d60000')};
    transform: translateY(-1px);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(214, 0, 0, 0.12);
  }

  svg {
    font-size: 9px;
    color: inherit;
  }
`

export const SummaryField = styled.div`
  position: relative;

  textarea {
    width: 100%;
    min-height: 180px;
    padding: 13px 14px 28px;
    border: 1px solid #dedede;
    border-radius: 10px;
    background: #fff;
    color: #3d3d3d;
    font-family: inherit;
    font-size: 11px;
    line-height: 1.55;
    resize: vertical;
    outline: none;
  }

  textarea:focus {
    border-color: #d90000;
    box-shadow: 0 0 0 3px rgba(217, 0, 0, 0.06);
  }

  small {
    position: absolute;
    right: 10px;
    bottom: 8px;
    color: #999;
    font-size: 9px;
  }
`

export const PublishPreview = styled.div<{ $private: boolean }>`
  padding: 14px;
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: ({$private}) => ($private ? '#f7f7f7': '#fff4f4');

  > svg {
    flex: 0 0 auto;
    margin-top: 2px;
    color: ({$private}) => ($private ? '#626262': '#d60000');
    font-size: 14px;
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  strong {
    color: #353535;
    font-size: 11px;
  }

  span {
    color: #7d7d7d;
    font-size: 9px;
    line-height: 1.45;
  }
`

export const FinalActions = styled.div`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  @media (max-width: 560px) {
    flex-direction: column-reverse;

    > * {
      width: 100%;
    }
  }
`

export const CreateDaysWorkspace = styled.div`
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
`

export const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const FileInput = styled.input`
  padding-bottom: 20px;
  font-size: 0;
  ::-webkit-file-upload-button {
    visibility: hidden;
  }
  ::after {
    visibility: hidden;
  }
  ::before {
    content: 'Escolha a capa da sua viagem';
    display: inline-block;
    background: linear-gradient(top, #f9f9f9, #e3e3e3);
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 600;
    font-size: 10pt;
  }
  :hover::before {
    border-color: #343434;
  }
  :active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  }
`

export const CheckboxLabel = styled.label`
  font-size: 14px;
  margin-top: 10px;
  color: #4f4f4f;
  font-weight: 600;
`

export const CheckboxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 40px;

  margin: 0 auto;
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const Checkbox = styled.input`
  width: 15px;
  height: 15px;
  margin-right: 10px;
  margin-top: 10px;
`

export const FormCreateItinerary = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const FormContainerCreateItinerary = styled.div`
  padding: 28px 24px 34px;
  height: auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const RadioButton = styled.button`
  width: 15px;
  height: 15px;
  margin-right: 10px;
  margin-top: 10px;
  border-radius: 100%;
`

export const OptionsCreateItinerary = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
`

export const ScriptCreateItinerary = styled.div`
  display: flex;
  flex-direction: column;
`

export const OptionCreateItinerary = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  & input,
  & label {
    margin: 0;
    padding: 0;
  }
`
